import { CloseWizardButton } from './CloseWizardButton';

export default CloseWizardButton;
